import React from 'react';

/**
 * Bandera de país como imagen: los emojis de bandera no se dibujan en Windows,
 * así que en el escritorio no se veían. Las imágenes se ven en todos los equipos.
 */
export const Flag = ({ code, title, className = '' }) => {
  if (!code || code.length !== 2) return null;
  const cc = code.toLowerCase();
  return (
    <img
      src={`https://flagcdn.com/w40/${cc}.png`}
      srcSet={`https://flagcdn.com/w80/${cc}.png 2x`}
      width={20}
      height={15}
      loading="lazy"
      alt={title || cc.toUpperCase()}
      title={title || undefined}
      data-testid={`flag-${cc}`}
      className={`inline-block rounded-[2px] shadow-sm align-middle object-cover ${className}`}
    />
  );
};
